import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function getReportedCasesAPI() {
  const url = `${AWS_API_URL}/reports`;

  return getRequest(url, await authorize());
}
